import React, { FC } from "react";
import { ResourceTypeLink } from "@evergis/api";

import { useDialogInfo } from "../../../../hooks/useDialogs";
import { LayerSettings } from "./Layer/LayerSettings";
import { QueryLayerResource } from "./QueryLayerResource/QueryLayerResource";
import { ProjectSettings } from "./Project/ProjectSettings";
import { TableSettings } from "./Table/TableSettings";

export const EditResource: FC = () => {
  const {
    resources: [, resourceType, sourceType],
  } = useDialogInfo(true);

  switch (resourceType) {
    case ResourceTypeLink.Project:
      return <ProjectSettings />;
    case ResourceTypeLink.Layer:
      if (sourceType === "QueryLayerService") {
        return <QueryLayerResource />;
      }

      return <LayerSettings />;
    case ResourceTypeLink.Table:
      return <TableSettings />;
    default:
      return null;
  }
};
